import { actions } from '../../resource';

export const NAMESPACE = 'SERVER/LINKS';
const resourceActions = actions.factory(NAMESPACE);

export const {
  LOAD,
  LOAD_SUCCESS,
  LOAD_ERROR,
} = resourceActions.TYPES;

export const {
  load,
  loadSuccess,
  loadError,
} = resourceActions;
